//returns Date without applying current time zone
export const parseDate = (d: string) => d ? new Date(...(d.substring(0, 10).split('-').map((s: string, i: number) => i == 1 ? Number(s) - 1 : Number(s)) as [])) : ''